import { clsx } from "clsx";

import "./Block.css";

import type { CSSProperties, ReactNode } from "react";

export interface BlockProps {
  appearance?: "card" | "tile";
  children?: ReactNode;
  className?: string;
  elevation?: 0 | 1 | 2 | 3;
  style?: CSSProperties;
}

export function Block({
  appearance = "tile",
  children,
  className,
  elevation,
  style,
}: BlockProps) {
  return (
    <div
      className={clsx("Block", className)}
      data-appearance={appearance}
      data-elevation={elevation}
      style={style}
    >
      {children}
    </div>
  );
}
